/** First word repeated consecutively (case-insensitive), or null. */
export function findRepeatedWord(text: string): string | null {
  const words = text.trim().split(/[^\p{L}\p{N}]+/u).filter(Boolean);
  for (let i = 1; i < words.length; i += 1) {
    if (words[i].toLowerCase() === words[i - 1].toLowerCase()) {
      return words[i];
    }
  }
  return null;
}

/** First run of the same character repeated minRun+ times, or null. */
export function findConsecutiveRepeatedCharacter(text: string, minRun = 4): string | null {
  if (!text) return null;
  const re = new RegExp(`(.)\\1{${minRun - 1},}`, 'u');
  const match = text.match(re);
  return match ? match[0] : null;
}

/** Collapse character runs longer than maxRun (e.g. "ddddd" → "ddd"). */
export function limitConsecutiveRepeatedCharacters(text: string, maxRun = 3): string {
  if (!text) return text;
  const re = new RegExp(`(.)\\1{${maxRun},}`, 'gu');
  return text.replace(re, (_match, char: string) => char.repeat(maxRun));
}

export function validateOptionalDescription(description?: string): string | undefined {
  if (!description?.trim()) return undefined;

  const charRun = findConsecutiveRepeatedCharacter(description);
  if (charRun) {
    const sample = charRun.charAt(0).repeat(Math.min(4, charRun.length));
    return `Description cannot contain repeated characters (e.g. "${sample}")`;
  }

  const repeatedWord = findRepeatedWord(description);
  if (repeatedWord) {
    return `Description cannot contain repeated words ("${repeatedWord}")`;
  }

  return undefined;
}
